module.exports = __webpack_public_path__ + "img/pantalla1-3.52aa75a2.png";